<template>
    <div>
        <table style="width: 100%;background-color: white;border-collapse: collapse;">
            <tr :item="item" v-for="item in posts" style="border-bottom:1px solid #eadede">
                <td width="70%" style="padding: 5px">
                    <div class="exerciseTitle">
                        {{item.title}}
                        <br/>
                        <label v-if="$store.state.auth.user.role==2" style="font-weight: normal">bạn: </label>
                        <label v-if="$store.state.auth.user.role==2 && (item.status == 0 || item.status == null)" style="color:red"> chưa làm</label>
                        <label v-if="$store.state.auth.user.role==2 && (item.status == 1)" style="color:red;"> đang làm</label>
                        <label v-if="$store.state.auth.user.role==2 && (item.status >1)" class="primaryColor"> đã nộp</label>
                    </div>
                    <!--div class="exerciseInfo">Đã giao: {{getNumberOfReceiver(item)}}</div-->
                    <!--div class="exerciseInfo">Đã làm: {{getNumberOfComplete(item)}}</div-->
                    <div v-if="$store.state.auth.user.role==4">
                        Đã nộp:
                        {{item.numberOfComplete}}/{{getNumberOfReceiver(item)}}
                    </div>
                    <div v-if="$store.state.auth.user.role==4">
                        Đã chấm:
                        {{item.numberOfMarked!=null?item.numberOfMarked:0}}/{{getNumberOfReceiver(item)}}
                    </div>
                </td>
                <td width="30%">
                    <v-btn flat  outline @click="onView(item)" color="#00ab4d" round small
                           v-if="$store.state.auth.user.role==4 && (item.numberOfMarked == null || item.numberOfMarked < getNumberOfReceiver(item)) && item.numberOfComplete>0">
                        <!--v-icon small>visibility</v-icon-->Chấm bài
                    </v-btn>
                    <v-btn flat outline @click="onViewExerciseReport(item)" color="#00ab4d" round small
                           v-else-if="$store.state.auth.user.role==4 && item.numberOfMarked == getNumberOfReceiver(item)">
                        <!--v-icon small>bar_chart</v-icon-->Gửi báo cáo
                    </v-btn>
                    <v-btn flat outline @click="onView(item)" color="#00ab4d" round small
                           v-else-if="$store.state.auth.user.role==2 && item.status >1">
                        <!--v-icon small>visibility</v-icon-->Xem lại bài
                    </v-btn>
                    <v-btn flat outline @click="onView(item)" color="orange" round small
                           v-else-if="$store.state.auth.user.role==2 && isExpire(item.dueDate)">
                        <!--v-icon small>visibility</v-icon-->Làm Offline
                    </v-btn>
                    <v-btn flat outline @click="onView(item)" color="#00ab4d" round small
                           v-else-if="$store.state.auth.user.role==2 && item.status==0">
                        <!--v-icon small>visibility</v-icon-->Làm bài
                    </v-btn>
                    <v-btn flat outline @click="onView(item)" color="#00ab4d" round small
                           v-else-if="$store.state.auth.user.role==2 && item.status==1">
                        <!--v-icon small>visibility</v-icon-->
                        Tiếp tục làm bài
                    </v-btn>
                    <v-btn flat outline @click="onView(item)" color="#00ab4d" round small
                           v-else>
                        <!--v-icon small>visibility</v-icon-->
                        Xem bài
                    </v-btn>
                </td>
            </tr>
        </table>
        <div v-if="posts.length == 0"
             style="font-weight: bold;text-align: center;padding-top: 10px;">
            Không có bài tập
        </div>
    </div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import Post from "./post";
    import EssayCreate from "./essayQuestion";
    import QuizCreate from "./quizQuestion";
    import TeacherViewQuestion from "./teacherViewQuestion";
    import StudentViewQuestion from "./studentViewQuestion";
    import MatrixPage from "./matrix/matrixPage";
    import moment from "moment";

    export default {
        name: "exercise-dashboard",
        components: {
        },
        props: {
            objectType: {
                type: String | Number,
                default: 0
            },
            classId: {
                type: String | Number,
                default: null
            },

        },

        watch: {
            classId: function (data) {
                this.getPost();
            }
        },

        computed: {
        },

        data() {
            return {
                postCount: 0,
                posts: [],
                page:1,
                pageSize:5
            }
        },

        created() {
            this.getPost();
        },

        methods: {
            isExpire(time){
                time = time +"T23:59:59";
                let now = new Date();
                let t = new Date(time);
                if (t.getTime() < now.getTime()) {
                    return true;
                } else {
                    return false;
                }

            },

            calculateRemainTime: function () {
                for (let i = 0; i < this.notSendPost.length; i++) {
                    let item = this.notSendPost[i];
                    if (item.status >= 2) {
                        item.remainTime = "Đã kết thúc";
                    } else {
                        if (item.questionTime == null || item.questionTime == "") {
                            item.remainTime = "";
                        } else {
                            let now = new Date();
                            let start = new Date(item.startTime);
                            let questionTime = item.questionTime * 60;
                            let duration = questionTime - parseInt((now.getTime() - start.getTime()) / 1000);
                            if (duration < 0) {
                                item.remainTime = "Hết giờ";
                            } else {
                                let second = duration % 60;
                                duration = parseInt(duration / 60);
                                let minutes = duration % 60; //minutes instead of asMinutes
                                duration = parseInt(duration / 60);
                                let hours = duration % 24; //hours instead of asHours
                                item.remainTime = hours + "h:" + minutes + "m:" + second + "s";
                            }
                        }
                    }
                }

                let temp = [];
                for (let i = 0; i < this.notSendPost.length; i++) {
                    temp.push(this.notSendPost[i]);
                }
                this.notSendPost = temp;
                //console.log(this.notSendPost);
            },

            getNumberOfReceiver(item) {
                if (item.receivers == null || item.receivers == "") {
                    return ""
                } else {
                    return item.receivers.split(",").length;
                }
            },

            getNumberOfComplete(item) {
                if (item.numberOfComplete == null) {
                    item.numberOfComplete = 0;
                }
                return item.numberOfComplete;
            },

            getRemainTime(time) {
                let now = new Date();
                let t = new Date(time);
                if (t.getTime() < now.getTime()) {
                    return "<label style='color:red'>(Đã hết hạn)</label>";
                } else {
                    return "<label style='color:blue'>(" + moment(time).fromNow() + ")</label>";
                }
            },

            getExerciseType(type) {
                if (type == 5) {
                    return "Tự luận"
                } else if (type == 6) {
                    return "Trắc nghiệm";
                }
            },

            onView: function (item) {
                this.$emit("view", item);
            },

            onViewExerciseReport: function (item) {
                this.$emit("exercise_report", item);
            },

            getPost: function () {
                let url;
                if(this.$store.state.auth.user.role == 4 || this.$store.state.auth.user.role == 1 ) {
                    url = process.env.VUE_APP_API_URL + "/post/onSearchDashboardExercise?classId=" + this.classId + "&page=" + this.page + "&pageSize=" + this.pageSize;
                } else {
                    url = process.env.VUE_APP_API_URL + "/post/onSearchUnsentExercise?classId=" + this.classId + "&page=" + this.page + "&pageSize=" + this.pageSize;
                }
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }
                console.log(url);
                axios.post(url).then(
                    data => {
                        this.postCount = data.count;
                        this.posts = data.items;
                        //console.log(this.posts);
                    },
                    error => {

                    }
                )
            },
        }
    };
</script>
<style>
    .exerciseTitle {
        font-weight: bold;
    }

    .exerciseTitle label {
        font-weight: normal;
    }

    .exerciseInfo {
        font-style: italic;
        font-size: 12px;
    }
</style>